// طباعة ملصق QR داخل التطبيق عبر iframe مخفي (بلا صفحة جديدة). الرمز صورة PNG بحجم ~نصف A4.
export const printQrZone = (zone, branchName, t, png) => {
  const html = `<!doctype html><html dir="rtl"><head><meta charset="utf-8">
  <title>${zone.name}</title>
  <style>
    @page{size:A4;margin:16mm}
    html,body{height:100%}
    body{font-family:system-ui,'Segoe UI',Tahoma;margin:0;display:flex;align-items:center;
      justify-content:center;background:#fff;color:#111}
    .card{text-align:center;border:4px solid #111;border-radius:24px;padding:14mm 18mm}
    h1{font-size:13mm;line-height:1.1;margin:0 0 3mm}
    h2{font-size:6mm;font-weight:600;margin:0 0 7mm;color:#444}
    img{width:95mm;height:95mm;display:block;margin:0 auto}
    .code{font-family:ui-monospace,monospace;letter-spacing:3mm;font-size:7mm;margin-top:6mm}
    .hint{margin-top:5mm;font-size:4.5mm;color:#555}
  </style></head><body><div class="card">
    <h1>${zone.name}</h1>
    <h2>${branchName || ""}${zone.floor ? ` · ${t("qr.floor")}: ${zone.floor}` : ""}</h2>
    <img src="${png || ""}" alt="QR">
    <div class="code">${zone.code}</div>
    <p class="hint">${t("qr.printHint")}</p>
  </div></body></html>`;

  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden";
  document.body.appendChild(frame);
  const cleanup = () => setTimeout(() => frame.remove(), 1000);
  const doc = frame.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();
  frame.contentWindow.onafterprint = cleanup;
  setTimeout(() => {
    try {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    } catch {
      frame.remove();
    }
  }, 450);
};
